/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  MessageType,
  MessageTypeFromJSON,
  MessageTypeFromJSONTyped,
  MessageTypeToJSON,
} from "./MessageType";

/**
 *
 * @export
 * @interface MessageTypeListResponse
 */
export interface MessageTypeListResponse {
  /**
   *
   * @type {number}
   * @memberof MessageTypeListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof MessageTypeListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof MessageTypeListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof MessageTypeListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof MessageTypeListResponse
   */
  count: number;
  /**
   *
   * @type {Array<MessageType>}
   * @memberof MessageTypeListResponse
   */
  data: Array<MessageType>;
}

export function MessageTypeListResponseFromJSON(
  json: any
): MessageTypeListResponse {
  return MessageTypeListResponseFromJSONTyped(json, false);
}

export function MessageTypeListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MessageTypeListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(MessageTypeFromJSON),
  };
}

export function MessageTypeListResponseToJSON(
  value?: MessageTypeListResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(MessageTypeToJSON),
  };
}
